import styled from 'styled-components';

export const FilterandProductGrid = styled.section`
  display: grid;
  grid-template-columns: ${(props) => (props.filter ? '20% 78%' : '100%')};
  max-width: ${(props) => (props.filter ? 'auto' : '85%')};
  margin: auto;
  @media (max-width: 720px) {
    grid-template-columns: 100%;
    max-width: 100%;
    margin: 0;
  }
`;
export const MdContainer = styled.div`
  @media (min-width: 768px) {
    margin-left: -24px;
  }
`;
export const FilterAside = styled.aside`
  padding: 16px 30px 16px 0;
  position: sticky;
  top: 122px;
  height: 600px;
  z-index: 9;
  @media (max-width: 720px) {
    display: none;
  }

  h4 {
    font-size: 16px;
    color: hsl(0deg, 0%, 0%, 80%);
    padding: 0 0 10px 18px;
    letter-spacing: 1.2px;
  }
`;

export const FilterSection = styled.section`
  border-top: 1px solid hsl(0deg, 0%, 0%, 10%);
  border-right: 1px solid hsl(0deg, 0%, 0%, 10%);
  height: calc(100vh - 130px);
  width: 100%;
  padding: 16px 8px 16px 8px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0;
    transition: all 0.3s ease;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &:hover {
    &::-webkit-scrollbar {
      width: 3px;
    }
  }
`;

export const FilterTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 8px 18px 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  @media (max-width: 720px) {
    cursor: default;
  }

  &:hover {
    background-color: #63b0a81c;
  }

  span {
    color: hsl(0deg, 0%, 0%, 80%);
    font-size: 15px;
    font-weight: 500;
  }

  &.selected {
    background-color: #63b0a81c;

    h1 {
      font-weight: 600;
    }
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const LthreeList = styled.ul`
  li {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: hsl(0deg, 0%, 0%, 60%);
  }
  .selected {
    background-color: #63b0a81c;

    h1 {
      font-weight: 600;
    }
  }
`;

export const FilterList = styled.ul`
  li {
    padding: 12px 8px 12px 18px;
    cursor: pointer;

    @media (max-width: 720px) {
      cursor: default;
    }

    .selected {
      background-color: #63b0a81c;
    }

    &:hover {
      background-color: #63b0a81c;
    }

    .category_form_group {
      display: block;

      input {
        padding: 0;
        height: initial;
        width: initial;
        margin-bottom: 0;
        display: none;
        cursor: pointer;
        transition: all 0.4s ease-in-out;

        &:checked + label:before {
          content: '';
          display: block;
          position: absolute;
          top: 4px;
          right: 6px;
          width: 4px;
          height: 8px;
          z-index: 9;
          border: 1px solid #fff;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
        &:checked + label {
          color: hsl(0deg, 0%, 0%, 87%);
          &:after {
            border: 1px solid hsl(0deg, 0%, 0%, 87%);
            background: hsl(0deg, 0%, 0%, 80%);
          }
        }
      }
      label {
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: hsl(0deg, 0%, 0%, 48%);
        transition: all 0.4s ease-in-out;

        &:after {
          content: '';
          appearance: none;
          background-color: transparent;
          border: 1px solid #0000004d;
          border-radius: 2px;
          padding: 7px;
          display: inline-block;
          position: relative;
          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }
`;
